<template>
  <modal name="saveRecord" transition="nice-modal-fade" :pivotY="0.3" @before-open="open" :clickToClose="false">
    <div class="save-record" @keydown.stop>
      <div v-if="status === 0">
        <div class="title">
          <span>保存录音</span>
          <div class="close-button" @click="close">
            <i></i>
          </div>
        </div>
        <div class="set-name">
          <p>录音名称</p>
          <input type="text" v-model="name" placeholder="请输入录音名称,以帮助您更好管理录音" maxlength="16">
          <div>{{name.length}}/16</div>
        </div>
        <div class="radios">
          <div class="radios__title">
            将录音添加至
          </div>
          <ul class="radios__list">
            <li class="radios__item" 
            :class="{active: item.active}" 
            v-for="(item, key) in positionList" 
            :key="key"
            @click="selectRadio(item, key)">
              <i></i>
              <span>{{item.text}}</span>
            </li>
          </ul>
        </div>
        <div class="button-content">
          <el-button type="primary" @click="saveUpload()">确定</el-button>
        </div>
      </div>
      <div v-else>
        <div class="upload-help">
          <div>录音正在上传中</div>
        </div>
        <div class="upload-cancel">
          <el-button @click="cancelUpload()">取消上传</el-button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'saveRecord',
  data () {
    return {
      ANALYSIS: {
        save : {category:'recording_classification', action:'click_save_recording', label:'保存录音'},
        cancel : {category:'recording_classification', action:'click_cancel_uploading_of_recording', label:'取消上传录音'},
      },
      name: '',
      type: '',
      status: 0,
      positionList: [
        {type: 'select', text: '当前页面', active: false},
        {type: 'all', text: '整个视频', active: false},
      ],
      number: 1
    }
  },
  mounted () {
    this.$bus.on('record_upload_success', () => {
      this.close();
    })
  },
  methods: {
    open (e) {
      this.name = '';
      this.status = 0;
      this.type = e.params.type;
      this.positionList.forEach((val, k) => {
        val.active = false;
        this.type === val.type && (val.active = true);
      })
    },
    selectRadio (item, key) {
      if(item.active) return;
      this.positionList.forEach((val, k) => {
        val.active = false;
        this.type = val.type;
        k === key && (val.active = true);
      })
    },
    saveUpload() {
      if(this.name.length <= 0) {
        this.name = '未命名录音' + (this.number <=10 ? '0' + this.number : this.number);
        this.number++ ;
      }
      this.$bus.emit('saveUploadRecord', {
        name: this.name,
        select: this.type
      })
      this.status = 1;
      this.$analysis(this.ANALYSIS.save)
    },
    close () {
      this.$modal.hide('saveRecord');
    },
    cancelUpload(){
      this.close();
      this.$bus.emit('record_close_complete')
      this.$analysis(this.ANALYSIS.cancel)
    }
  }
}
</script>


<style lang="scss" scoped>
.save-record {
  position: relative;
  margin: auto;
  width: 370px;
  height: 240px;
  background: #fff;
  border-radius: 3px;
  color: #474261;
  overflow: hidden;
}
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px 0 15px;
  height: 28px;
  background-color: #d8dee9;
  color: #474261;
}
div.close-button {
  position: absolute;
  right: 10px;
  top: 5px;
  width: 16px;
  cursor: pointer;

  i {
    position:relative;
    left: 7px;
    top: 2px;
    width: 2px;
    height: 15px;
    border-radius: 3px;
    background: #737596;
    transform: rotate(45deg);
    display: inline-block;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 2px;
      height: 15px;
      border-radius: 3px;
      background: #737596;
      transform: rotate(270deg);
    }
  }
}

.set-name {
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 20px;
  margin-top: 40px;

  p {
    margin-bottom: 13px;
    font-size: 14px;
  }
  input {
    height: 37px;
    width: 100%;
    padding-left: 12px;
    box-sizing: border-box;
    background-color: #f6f6fc;
    border-radius: 2px;
    border: none;

    &::placeholder {
      color: #9692A9;
    }
  }
  div {
    position: relative;
    top: -26px;
    right: -280px;
    width: 40px;
    text-align: right;
  }
}

.radios {
  display: none;
  width: 240px;
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 20px;

  &__title {
    margin-bottom: 13px;
    font-size: 14px;
    text-align-last: left;
  }

  &__list {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__item {
    display: flex;
    align-items: center;
    font-size: 14px;
    cursor: pointer;

    &>i {
      width: 16px;
      height: 16px;
      border-radius: 16px;
      border: solid 1px #9692a9;
    }
    &>span {
      padding-left: 5px;
    }

    &.active>i {
      background-color: #9692a9;
      box-shadow: 0 0 0 2px #ffffff inset;
    }
  }
}
.button-content {
  text-align: center;

  button {
    height: 36px;
    padding: 10px 34px;
  }
}
.upload-help {
  margin-top: 80px;
  font-size: 20px;
  text-align: center;
}
.upload-cancel {
  margin-top: 20px;
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/components/emodal/record/saveRecord.vue